export default (props, vars) =>
  vars?.['usestatepresentationpopupopened']?.['state'] !== undefined;
